import React, { memo, Suspense } from 'react';
import PropTypes from 'prop-types';
import { LeaseDealsEntities } from 'site-modules/lease-deals/constants/prop-types';
import { LeaseDealsCard } from 'client/site-modules/lease-deals/components/lease-deals-card/lease-deals-card';
import { ErrorBoundary } from 'site-modules/shared/components/error-boundary/error-boundary';

import './lease-deals-grid-view-card-list.scss';

export const LeaseDealsGridViewCardList = memo(
  ({ deals, photos = undefined, isMobile, isShop4931ZeroDownRoute = false }) => {
    return (
      <ul className="list-unstyled pb-0 row">
        {deals.map((deal, index) => {
          const photo = photos?.find(({ styleIds }) => styleIds[deal.styleId]);
          return (
            <ErrorBoundary key={deal.styleId}>
              <Suspense fallback={null}>
                <li className="lease-deals-card-item mb-1_5 col col-sm-12 col-lg-6 col-xl-4 px-0_75">
                  <LeaseDealsCard
                    photo={photo}
                    isLazyImage={!!index}
                    isMobile={isMobile}
                    isShop4931ZeroDownRoute={isShop4931ZeroDownRoute}
                    {...deal}
                  />
                </li>
              </Suspense>
            </ErrorBoundary>
          );
        })}
      </ul>
    );
  }
);

LeaseDealsGridViewCardList.propTypes = {
  deals: LeaseDealsEntities.Deals.isRequired,
  photos: PropTypes.arrayOf(PropTypes.shape({})),
  isMobile: PropTypes.bool.isRequired,
  isShop4931ZeroDownRoute: PropTypes.bool,
};

LeaseDealsGridViewCardList.displayName = 'LeaseDealsGridViewCardList';
